import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AppContext } from "../../context/AppContext";
import "./assets/css/createmenu.css";

const CreateMenuBar = () => {
  const { baseUrl, token, setgamelist } = useContext(AppContext);
  const [name, setName] = useState("");
  const [route, setRoute] = useState("");
  const [status, setStatus] = useState("");
  const [menuList, setMenuList] = useState([]);
  const [editId, setEditId] = useState(null);
  const [getCategory, setGetCategory] = useState([]);
  const [MenuSubCategory, setMenuSubCategory] = useState([]);

  useEffect(() => {
    fetchMenus();
    fetchData();
  }, []);

  const fetchMenus = async () => {
    try {
      const res = await axios.get(`${baseUrl}/get-menus`);
      if (res.data.success) {
        setMenuList(res.data.data);
        
      }
    } catch (err) {
      console.error("Error fetching menus:", err);
    }
  };
  const fetchData = async () => {
    try {
      const res = await axios.get(`${baseUrl}/get-category`);
      if (res.data.success) {
        setGetCategory(res.data.data);
        
      } else {
        console.error("Failed to fetch categories:", res.data.message);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
    try {
      const res = await axios.get(`${baseUrl}/get-game-list`);
      if (res.data.message) {
        setgamelist(res.data.getAllGame);
        
      } else {
        console.error("Failed to fetch game list:", res.data.message);
      }
    } catch (err) {
      console.error("Error fetching game list:", err);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !route) {
      setStatus("Both fields are required.");
      return;
    }

    try {
      const res = await axios.post(
        `${baseUrl}/save-menu`,
        {
          name,
          route,
          MenuSubCategory,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.success) {
        setStatus("Menu saved successfully!");
        setName("");
        setRoute("");
        fetchMenus();
      } else {
        setStatus(res.data.message || "Failed to save menu.");
      }
    } catch (err) {
      console.error("Error saving menu:", err);
      setStatus("Error while saving menu.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this menu?")) return;
    try {
      const res = await axios.delete(`${baseUrl}/delete-menu/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.data.success) {
        fetchMenus();
      }
    } catch (err) {
      console.error("Error deleting menu:", err);
    }
  };

  const handleEdit = (menu) => {
    setEditId(menu.id);
    setName(menu.name);
    setRoute(menu.route);
    
    setMenuSubCategory(menu.subcategory || []);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!editId) return;

    try {
      const res = await axios.put(
        `${baseUrl}/update-menu/${editId}`,
        {
          name,
          route,
          MenuSubCategory,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.data.success) {
        setStatus("Menu updated successfully!");
        setName("");
        setRoute("");
        setEditId(null);
        fetchMenus();
      }
    } catch (err) {
      console.error("Error updating menu:", err);
      setStatus("Error while updating menu.");
    }
  };

  return (
    <div className="container">
      {/* Add/Edit Form */}
      <div className="menu_main">
        <h1 className="heading">{editId ? "Edit Menu" : "Add Menu"}</h1>
      </div>
      <div className="add_menu_main">
        <div className="menu_main_model">
          <form
            onSubmit={editId ? handleUpdate : handleSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <div className="form_field">
              <label>Menu Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="form-control"
              />
            </div>
            <div className="form_field">
              <label>Category</label>
              <select
                name="category"
                required
                multiple
                size={15}
                className="form-control"
                value={MenuSubCategory}
                onChange={(e) => {
                  //setRoute(e.target.value);
                  const selectedOptions = Array.from(
                    e.target.selectedOptions
                  ).map((option) => option.value);

                  setMenuSubCategory(selectedOptions);
                }}
              >
                <option value="">Select Category</option>
                {getCategory.map(
                  (category, index) =>
                    category && (
                      <option key={index} value={category.id}>
                        {category.name}
                      </option>
                    )
                )}
              </select>
            </div>
            <div className="form_field">
              <label>Route</label>
              <input
                type="text"
                value={route}
                onChange={(e) => setRoute(e.target.value)}
                required
                placeholder="example"
                className="form-control"
              />
            </div>

            <div class="form_btn">
              <button type="submit" className="btn btn-primary">
                {editId ? "Update Menu" : "Save Menu"}
              </button>

              {status && (
                <div style={{ marginTop: "10px", color: "green" }}>
                  {status}
                </div>
              )}
            </div>
          </form>
        </div>
      </div>

      {/* Menu List */}
      <div className="category_list">
        <h2>Menu List</h2>
        <div className="table_main">
          <table
            className="table table-bordered"
            style={{
              width: "100%",
              textAlign: "center",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr
                style={{ backgroundColor: "#f2f2f2", border: "1px solid #ddd" }}
              >
                <th>ID</th>
                <th>Menu Name</th>
                <th>Route</th>
                <th>Sub Category</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {menuList.map((menu, index) => (
                <tr
                  key={menu.id}
                  style={{
                    border: "1px solid #ddd",
                    textAlign: "center",
                  }}
                >
                  <td>{index + 1}</td>
                  <td>{menu.name}</td>
                  <td>{menu.route}</td>
                  <td>
                    {Array.isArray(menu.subcategory)
                      ? menu.subcategory.join(", ")
                      : menu.subcategory}
                  </td>
                  <td>
                    <button onClick={() => handleEdit(menu)} className="edit">
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(menu.id)}
                      className="delete"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {menuList.length === 0 && (
                <tr>
                  <td colSpan="4">No menus found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CreateMenuBar;
